import { useFetchFavoriteMatchIds } from 'newhooks/sportsbook/favorites/useFetchFavoriteMatchIds';

export const FetchFavoriteMatchIds = () => {
  useFetchFavoriteMatchIds();

  return null;
};
